module.exports = __webpack_public_path__ + "static/media/awsnto32_50.6b1ec3ff.ico";